import { useState } from 'react';

const INITIAL = {
  first_name: '',
  preferred_contact: '',
  email: '',
  phone: '',
  service_category: '',
  location: '',
  timing: '',
  budget_range: '',
  job_details: '',
  share_consent: false,
  contact_consent: false,
  privacy_acknowledgement: false,
};

export default function CustomerQuoteForm() {
  const [form, setForm] = useState(INITIAL);
  const [submitted, setSubmitted] = useState(false);
  const [buttonText, setButtonText] = useState('Request quotes');

  function onChange(e) {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  }

  function onSubmit(e) {
    e.preventDefault();
    if (!form.email.trim() && !form.phone.trim()) {
      alert('Please add at least one contact method: email or phone.');
      return;
    }

    const body = new URLSearchParams({ 'form-name': 'customer-quote-request', ...form });
    fetch('/', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body })
      .then(() => {
        setSubmitted(true);
        setButtonText('Request captured');
        setTimeout(() => {
          setSubmitted(false);
          setButtonText('Request quotes');
        }, 2600);
        setForm(INITIAL);
      })
      .catch(() => alert('Something went wrong. Please try again.'));
  }

  return (
    <form
      name="customer-quote-request"
      method="POST"
      data-netlify="true"
      netlify-honeypot="bot-field"
      className={`quote-form reveal delay-1${submitted ? ' submitted' : ''}`}
      onSubmit={onSubmit}
    >
      <input type="hidden" name="form-name" value="customer-quote-request" />
      <p className="hidden"><label>Do not fill this out: <input name="bot-field" /></label></p>

      <div className="form-row two">
        <label>First name
          <input name="first_name" autoComplete="given-name" required placeholder="Your first name" value={form.first_name} onChange={onChange} />
        </label>
        <label>Preferred contact
          <select name="preferred_contact" required value={form.preferred_contact} onChange={onChange}>
            <option value="">Select one</option>
            <option>Email</option>
            <option>Phone</option>
          </select>
        </label>
      </div>

      <div className="form-row two">
        <label>Email
          <input name="email" type="email" autoComplete="email" placeholder="you@example.com" value={form.email} onChange={onChange} />
        </label>
        <label>Phone
          <input name="phone" type="tel" autoComplete="tel" placeholder="Optional if email is preferred" value={form.phone} onChange={onChange} />
        </label>
      </div>

      <div className="form-row two">
        <label>Service category
          <select name="service_category" required value={form.service_category} onChange={onChange}>
            <option value="">Choose category</option>
            <option>Movers</option>
            <option>Move-in / move-out cleaning</option>
            <option>Handyman / furniture assembly</option>
            <option>Painting</option>
            <option>Internet / mobile setup</option>
            <option>Tenant / home insurance</option>
            <option>Auto insurance</option>
            <option>Other local service</option>
          </select>
        </label>
        <label>Location
          <input name="location" required placeholder="City + postal code only" value={form.location} onChange={onChange} />
        </label>
      </div>

      <div className="form-row two">
        <label>Timing
          <input name="timing" placeholder="This week, next month, flexible..." value={form.timing} onChange={onChange} />
        </label>
        <label>Budget range
          <select name="budget_range" value={form.budget_range} onChange={onChange}>
            <option value="">Optional</option>
            <option>Under $250</option>
            <option>$250–$500</option>
            <option>$500–$1,000</option>
            <option>$1,000+</option>
            <option>Not sure yet</option>
          </select>
        </label>
      </div>

      <label>Job details
        <textarea name="job_details" rows="5" required placeholder="Briefly describe what you need. Avoid adding sensitive personal information." value={form.job_details} onChange={onChange} />
      </label>

      <div className="disclaimer-box">
        <strong>Insurance requests</strong>
        <p>Quoteramaa connects you with licensed insurance professionals only. We do not provide insurance advice, recommend policies, sell insurance, bind coverage, or collect detailed underwriting information at this stage.</p>
      </div>

      <label className="check">
        <input name="share_consent" type="checkbox" required checked={form.share_consent} onChange={onChange} />
        <span>I consent to Quoteramaa collecting my request details and sharing relevant details with matched local businesses so I can receive quotes.</span>
      </label>

      <label className="check">
        <input name="contact_consent" type="checkbox" required checked={form.contact_consent} onChange={onChange} />
        <span>I agree that Quoteramaa and matched businesses may contact me about this request by my preferred contact method.</span>
      </label>

      <label className="check">
        <input name="privacy_acknowledgement" type="checkbox" required checked={form.privacy_acknowledgement} onChange={onChange} />
        <span>I understand Quoteramaa will use this information only to process my request, improve the service, and communicate with me. I can request deletion by contacting privacy@quoteramaa.ca.</span>
      </label>

      <button className="btn primary" type="submit">{buttonText}</button>
      <p className="success">Request received. We'll review it and contact you before sharing it with matched businesses.</p>
    </form>
  );
}
